import { render } from "./PublicProfileModal.vue?vue&type=template&id=ef9e1df2&scoped=true&ts=true"
import script from "./PublicProfileModal.vue?vue&type=script&lang=ts"
export * from "./PublicProfileModal.vue?vue&type=script&lang=ts"

import "./PublicProfileModal.vue?vue&type=style&index=0&id=ef9e1df2&scoped=true&lang=css"

import exportComponent from "/home/bisite/hyperlender/express-server/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef9e1df2"]])

export default __exports__